import React from "react";
import {
  FaCoins,
  FaFileAlt,
  FaUserShield,
  FaLaptopCode,
  FaBullhorn,
  FaRocket,
} from "react-icons/fa";

function Whitepaper() {
  return (
    <>
      <div
        className="process-style-two-area overflow-hidden bg-cover default-padding bg-dark text-light"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
        }}
      >
        <div className="container">
          <div className="site-heading">
            <div className="row align-center">
              <div className="col-lg-8">
                <h4 className="sub-title">Our Process</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Our Comprehensive ICO Development Solutions
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="process-style-two-items">
            <div className="row">
              {/* 1 */}
              <div className="col-lg-4 col-md-6">
                <div className="process-style-two-item">
                  <div className="icon pt-30">
                    <FaCoins size={40} />
                  </div>
                  <h4>Token Creation & Smart Contract Development</h4>
                  <p>
                    We design and deploy secure, custom tokens aligned with your
                    project’s unique requirements. Whether you’re launching an
                    ERC-20, BEP-20, or a custom protocol, our blockchain
                    developers ensure the technical foundation is robust and
                    secure.
                  </p>
                </div>
              </div>

              {/* 2 */}
              <div className="col-lg-4 col-md-6">
                <div className="process-style-two-item">
                  <div className="icon pt-30">
                    <FaFileAlt size={40} />
                  </div>
                  <h4>Whitepaper & Pitch Deck Creation</h4>
                  <p>
                    Our team collaborates with you to develop a compelling,
                    investor-ready whitepaper and pitch deck that effectively
                    communicates your project’s vision, market potential, and
                    tokenomics.
                  </p>
                </div>
              </div>

              {/* 3 */}
              <div className="col-lg-4 col-md-6">
                <div className="process-style-two-item">
                  <div className="icon pt-30">
                    <FaUserShield size={40} />
                  </div>
                  <h4>KYC/AML Compliance Integration</h4>
                  <p>
                    We prioritize regulatory compliance by integrating KYC and
                    AML processes, safeguarding your ICO against fraud and
                    ensuring adherence to legal standards.
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              {/* 4 */}
              <div className="col-lg-4 col-md-6">
                <div className="process-style-two-item">
                  <div className="icon pt-30">
                    <FaLaptopCode size={40} />
                  </div>
                  <h4>ICO Website and Dashboard Development</h4>
                  <p>
                    We create secure, user-friendly ICO platforms and dashboards
                    with payment gateways, multi-currency support, and real-time
                    analytics.
                  </p>
                </div>
              </div>

              {/* 5 */}
              <div className="col-lg-4 col-md-6">
                <div className="process-style-two-item">
                  <div className="icon pt-30">
                    <FaBullhorn size={40} />
                  </div>
                  <h4>Marketing and Community Management</h4>
                  <p>
                    Our marketing specialists boost your ICO visibility through
                    social media, content marketing, and strong
                    community-building strategies.
                  </p>
                </div>
              </div>

              {/* 6 */}
              <div className="col-lg-4 col-md-6">
                <div className="process-style-two-item">
                  <div className="icon pt-30">
                    <FaRocket size={40} />
                  </div>
                  <h4>Post-ICO Support and Exchange Listing</h4>
                  <p>
                    We assist with token distribution, exchange listings, and
                    ongoing technical support to ensure long-term project
                    growth.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Whitepaper;
